/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-extra-parens */
import React, { useCallback } from 'react';
import { getAnalytics, logEvent } from 'firebase/analytics';

import { ErrorBoundary } from 'react-error-boundary';
import { DisplayAdUnitWrapper } from './displayAdUnitWrapper';

type DisplayAdUnitProps = {
    width: number;
    height: number;
    slotId: string;
    showOnPhone?: boolean;
    showOnTablet?: boolean;
    showOnDesktop?: boolean;
    isInfiniteScrollAd?: boolean;
    infiniteScrollIndex?: number;
    refreshWatchParam?: string | number;
}

export const DisplayAdUnit = ({ 
    width,
    height,
    slotId,
    showOnDesktop = true,
    showOnPhone = true,
    showOnTablet = true,
    isInfiniteScrollAd,
    infiniteScrollIndex, 
    refreshWatchParam }: DisplayAdUnitProps) => {
    const handeOnError = useCallback((error: Error, info: { componentStack: string; }) => {
        const analytics = getAnalytics?.();
            
        if (!analytics) {
            return;
        }
        logEvent?.(analytics, 'legacy_xandr_ad_critical_error', {
            slot_id: slotId,
            message: error?.message
        });
    }, []);
    return (
        <ErrorBoundary
            onError={handeOnError}
            fallback={<span id='legacy-xandr-ad-fallback-error-ui' style={{ width: 0, height: 0, padding: 0, margin: 0 }}></span>}>
            <DisplayAdUnitWrapper
                slotId={slotId}
                width={width}
                height={height}
                showOnDesktop={showOnDesktop}
                showOnPhone={showOnPhone}
                showOnTablet={showOnTablet}
                isInfiniteScrollAd={isInfiniteScrollAd}
                infiniteScrollIndex={infiniteScrollIndex}
                refreshWatchParam={refreshWatchParam}
            />
        </ErrorBoundary>
    );
};